<template>
  <!-- Modal pit -->
  <b-modal id="pit-modal" centered header-class="border-0" footer-class="border-0">
    <div class="d-block text-center">
      <div v-if="data.uploading" class="spinner-container">
        <loading :active="true" color="var(--primary)" :is-full-page="false" loader="spinner" />
      </div>
      <div v-else :style="'padding-bottom: 2rem;' + data.color">
        <i :class="[data.iconName, 'fa-4x']"></i>
      </div>
      <h3 class="h6">{{ data.title }}</h3>
      <span class="d-block message-text">
        <span>{{ data.message }}</span>
        <b-button v-if="data.navigation" variant="link" class="ml-1 redirect-link p-0" @click="$emit('on-redirect')"
          >{{ $t('pit.productsInTest') }}
        </b-button>
      </span>
    </div>
    <template #modal-footer>
      <div class="w-100"></div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner-container {
  height: 64px;
  margin-bottom: 2rem;
  position: relative !important;
}
.redirect-link {
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
  text-decoration: none !important;
}

.message-text {
  font-size: 0.8rem;
}
</style>
